export default __webpack_public_path__ + "static/media/O-109.9222b788.png";